/**
 * Subscription Extension Modal Controller
 *
 * Manages the superadmin subscription extension modal
 * @module portal/modules/ui/modals/subscriptionModal
 */

import { getSelectedUserData } from '../../superadmin';
import { els } from '../elements';
import { showToast } from '../toasts';

/**
 * Open the subscription extension modal for the currently selected user
 */
export function openSubscriptionExtensionModal(): void {
  const userData = getSelectedUserData();
  if (!userData) {
    showToast('No user selected.', {
      type: 'error',
    });
    return;
  }

  if (els.subscriptionExtensionUserName) {
    const displayName = userData.displayName || userData.name || userData.email || 'User';
    els.subscriptionExtensionUserName.textContent = displayName;
  }

  if (els.subscriptionExtensionCurrentExpiration) {
    const expiresRaw = (userData as any).subscriptionExpiresAt;
    if (typeof expiresRaw === 'string' || typeof expiresRaw === 'number') {
      const dateStr = new Date(expiresRaw).toLocaleString();
      els.subscriptionExtensionCurrentExpiration.textContent = `Current expiration: ${dateStr}`;
    } else {
      els.subscriptionExtensionCurrentExpiration.textContent =
        'No expiration date set (will start from now)';
    }
  }

  if (els.subscriptionExtensionForm) {
    (els.subscriptionExtensionForm as HTMLFormElement).reset();
  }
  if (els.subscriptionNoteCharCount) {
    els.subscriptionNoteCharCount.textContent = '0';
  }

  if (els.subscriptionExtensionModalBackdrop) {
    els.subscriptionExtensionModalBackdrop.hidden = false;
  }
  if (els.subscriptionExtensionModal) {
    els.subscriptionExtensionModal.hidden = false;
  }

  if (els.subscriptionMonths) {
    setTimeout(() => (els.subscriptionMonths as HTMLElement).focus(), 100);
  }
}

/**
 * Close the subscription extension modal
 */
export function closeSubscriptionExtensionModal(): void {
  if (els.subscriptionExtensionModal) {
    els.subscriptionExtensionModal.hidden = true;
  }
  if (els.subscriptionExtensionModalBackdrop) {
    els.subscriptionExtensionModalBackdrop.hidden = true;
  }
}
